module.exports = __webpack_public_path__ + "img/type_group_activity@2x.3464ff99.png";